import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
import { isFlagSet, setFlag } from 'z3k-parser/lib/flags';
export var WebElement;
(function (WebElement) {
    let Type;
    (function (Type) {
        Type[Type["STATUS"] = 0] = "STATUS";
        Type[Type["SIMPLE"] = 1] = "SIMPLE";
        Type[Type["COMPLEX"] = 2] = "COMPLEX";
        Type[Type["ANALOG"] = 3] = "ANALOG";
    })(Type = WebElement.Type || (WebElement.Type = {}));
    let StatusFlags;
    (function (StatusFlags) {
        StatusFlags[StatusFlags["INIT"] = 1] = "INIT";
        StatusFlags[StatusFlags["ANALOG_OUTPUT_STATE_FORMAT"] = 2] = "ANALOG_OUTPUT_STATE_FORMAT";
    })(StatusFlags = WebElement.StatusFlags || (WebElement.StatusFlags = {}));
    let Flags;
    (function (Flags) {
        Flags[Flags["IS_OUTPUT_STATE_FLAG"] = 1] = "IS_OUTPUT_STATE_FLAG";
        Flags[Flags["SEND_STATE_TO_ML_FLAG"] = 2] = "SEND_STATE_TO_ML_FLAG";
        Flags[Flags["SEND_STATE_TO_USB_FLAG"] = 4] = "SEND_STATE_TO_USB_FLAG";
        Flags[Flags["FRAM_SAVED_STATE_FLAG"] = 8] = "FRAM_SAVED_STATE_FLAG";
        Flags[Flags["HIDDEN_CARD_FLAG"] = 16] = "HIDDEN_CARD_FLAG";
        Flags[Flags["HIDDEN_LABEL_FLAG"] = 32] = "HIDDEN_LABEL_FLAG";
        Flags[Flags["INVERSION_FLAG"] = 64] = "INVERSION_FLAG";
    })(Flags = WebElement.Flags || (WebElement.Flags = {}));
    let AliceView;
    (function (AliceView) {
        AliceView[AliceView["NOT_CHOSEN"] = 0] = "NOT_CHOSEN";
        AliceView[AliceView["Light"] = 1] = "Light";
        AliceView[AliceView["Openable"] = 2] = "Openable";
        AliceView[AliceView["Other"] = 3] = "Other";
        AliceView[AliceView["Socket"] = 4] = "Socket";
        AliceView[AliceView["Switch"] = 5] = "Switch";
        AliceView[AliceView["Ventilation"] = 6] = "Ventilation";
    })(AliceView = WebElement.AliceView || (WebElement.AliceView = {}));
    WebElement.get = createAccessors(arrayGetSet('web_elements'), {
        name: 'Элемент управления',
        type: 0,
        label1: '',
        label2: '',
        setting_register: 0,
        id_active: null,
        id_passive: null,
        position: 0,
        alice_view: 0,
    });
    function isStatusType(web_element) {
        return web_element.type === WebElement.Type.STATUS;
    }
    WebElement.isStatusType = isStatusType;
    function isSimpleType(web_element) {
        return web_element.type === WebElement.Type.SIMPLE;
    }
    WebElement.isSimpleType = isSimpleType;
    function isComplexType(web_element) {
        return web_element.type === WebElement.Type.COMPLEX;
    }
    WebElement.isComplexType = isComplexType;
    function isAnalogType(web_element) {
        return web_element.type === WebElement.Type.ANALOG;
    }
    WebElement.isAnalogType = isAnalogType;
    function isSetOutputState(web_element) {
        return isFlagSet(web_element, Flags.IS_OUTPUT_STATE_FLAG);
    }
    WebElement.isSetOutputState = isSetOutputState;
    function setOutputState(web_element, enabled) {
        return setFlag(web_element, Flags.IS_OUTPUT_STATE_FLAG, enabled);
    }
    WebElement.setOutputState = setOutputState;
    function isCardHidden(web_element) {
        return isFlagSet(web_element, Flags.HIDDEN_CARD_FLAG);
    }
    WebElement.isCardHidden = isCardHidden;
    function isLabelHidden(web_element) {
        return isFlagSet(web_element, Flags.HIDDEN_LABEL_FLAG);
    }
    WebElement.isLabelHidden = isLabelHidden;
    function isInverted(web_element) {
        return isFlagSet(web_element, Flags.INVERSION_FLAG);
    }
    WebElement.isInverted = isInverted;
    function setHiddenCardFlag(web_element, enabled) {
        return setFlag(web_element, Flags.HIDDEN_CARD_FLAG, enabled);
    }
    WebElement.setHiddenCardFlag = setHiddenCardFlag;
})(WebElement || (WebElement = {}));
